import { type FC } from "react";

import { t } from "i18n/i18n";
import { DropdownMenu } from "mds/components/DropdownMenu";
import { FolderIcon } from "mds/icons";
import { useAppSelector } from "store/index";
import { selectCourseCodeGroupings } from "store/selectors/base";

type CourseCodeGroupingDropdownProps = {
  selectedGroupingId: string | null;
  onSelectionChange: (groupingId: string | null) => void;
};

export const CourseCodeGroupingDropdown: FC<CourseCodeGroupingDropdownProps> = ({
  selectedGroupingId,
  onSelectionChange,
}) => {
  const groupings = useAppSelector(selectCourseCodeGroupings);

  const dropdownItems = [
    {
      id: "",
      title: t("home.course_codes.select_a_grouping"),
    },
    ...groupings.map((grouping) => ({
      id: grouping.id,
      title: grouping.title,
      iconStart: <FolderIcon />,
    })),
  ];

  return (
    <DropdownMenu
      buttonText={
        !selectedGroupingId ? (
          <div className="text-sm font-medium">{t("home.course_codes.select_a_grouping")}</div>
        ) : undefined
      }
      className="flex w-full items-center !justify-between"
      eventName="Add Course Code - Select Folder"
      items={dropdownItems}
      selectedValue={selectedGroupingId || ""}
      truncateWidth="max-w-full"
      onSelectionChange={(item) => {
        onSelectionChange(item.id === "" ? null : item.id);
      }}
    />
  );
};
